import { Map } from 'immutable';
import { dispatch } from 'nike-re-framejs';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { callSearch, getMatchIds, SEARCH_RESULT_MATCHES_BOXSTORE } from './services/results';
import { loadMatches } from '@/nikeone/services';
import { replaceLoadedBoxes } from '@/nikeone/handlers';

const searchSubscription = new Subject();
searchSubscription.pipe(debounceTime(500)).subscribe(searchText => {
    callSearch(searchText).then(searchData => {
        const resultsByType = searchData ? searchData.groupBy(item => item.get('type')) : Map();
        dispatch(updateSearchData(resultsByType, searchText));
    });
});

export const updateSearchText = searchText => db => {
    searchSubscription.next(searchText);
    return db.setIn(['search', 'searchText'], searchText);
};

export const updateSearchData = (searchData, searchText) => db =>
    db
        .setIn(['search', 'suggestion', 'searchData'], searchData)
        .setIn(['search', 'suggestion', 'searchText'], searchText);

export const onFullSearch = searchData => db => {
    const matchIds = getMatchIds(searchData);
    if (matchIds && matchIds.size) {
        loadMatches(matchIds).then(response => {
            dispatch(replaceLoadedBoxes(response, SEARCH_RESULT_MATCHES_BOXSTORE));
        });
    }
    const resultsByType = searchData ? searchData.groupBy(item => item.get('type')) : Map();
    return db.setIn(['search', 'result', 'searchData'], resultsByType);
};
